type ShowPurchaseSuccessFunction = (item: any) => void;

let showPurchaseSuccessFn: ShowPurchaseSuccessFunction = () => {};
let hidePurchaseSuccessFn: () => void = () => {};

export const modalService = {
  init: (showFn: ShowPurchaseSuccessFunction, hideFn: () => void) => {
    showPurchaseSuccessFn = showFn;
    hidePurchaseSuccessFn = hideFn;
  },

  showPurchaseSuccess: (item: any) => {
    showPurchaseSuccessFn(item);
  },

  hidePurchaseSuccess: () => {
    hidePurchaseSuccessFn();
  },
};
